/* Explicit request (2026-09-23): phone product cards swipe between their two photos (CSS in theme.css,
   ".product-item__media--swipe"); this lights the dot of the photo on screen. One capturing listener on the
   document covers every card, including the ones added later by "Cargar más" / infinite scroll.
   Follow-up the same day ("al deslizar quiero que cambie la img"): a finger swipes natively, but a MOUSE cannot drag
   a scroll strip, so on a narrow desktop window nothing moved. Mouse drag is handled here: the strip follows the
   pointer, then settles on the nearest photo (a short flick is enough to change photo). While dragging, the card's
   links lose their href for a moment: the theme's page-transition script follows any <a href> click even when the
   click is prevented, so releasing the mouse would otherwise open the product. */
(function () {
  var pending = new Set();
  var raf = null;
  function paint() {
    raf = null;
    pending.forEach(function (strip) {
      var media = strip.closest('.product-item__media--swipe');
      var dots = media && media.querySelectorAll('.product-item__dots i');
      if (!dots || !dots.length) return;
      var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    });
    pending.clear();
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('product-item__image-link')) return;
    pending.add(t);
    if (!raf) raf = requestAnimationFrame(paint);
  }, true);

  /* ---- mouse drag ---- */
  var drag = null;
  function stripFrom(target) {
    var strip = target && target.closest && target.closest('.product-item__media--swipe .product-item__image-link');
    return strip && strip.scrollWidth > strip.clientWidth + 1 ? strip : null;
  }
  function parkLinks(card, park) {
    card.querySelectorAll(park ? 'a[href]' : 'a[data-swipe-href]').forEach(function (a) {
      if (park) { a.setAttribute('data-swipe-href', a.getAttribute('href')); a.removeAttribute('href'); }
      else { a.setAttribute('href', a.getAttribute('data-swipe-href')); a.removeAttribute('data-swipe-href'); }
    });
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var strip = stripFrom(e.target);
    if (!strip) return;
    drag = { strip: strip, card: strip.closest('.product-item') || strip, x: e.clientX, left: strip.scrollLeft, moved: false };
  }, true);
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 5) return;
      drag.moved = true;
      drag.strip.style.scrollSnapType = 'none';
      drag.strip.style.cursor = 'grabbing';
      parkLinks(drag.card, true);
    }
    e.preventDefault();
    drag.strip.scrollLeft = drag.left - dx;
  });
  function endDrag(e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    var w = Math.max(1, d.strip.clientWidth);
    var start = Math.round(d.left / w);
    var dx = (e && e.clientX != null ? e.clientX : d.x) - d.x;
    var i = start;
    if (dx < -30) i = start + 1;
    else if (dx > 30) i = start - 1;
    var max = Math.round((d.strip.scrollWidth - w) / w);
    i = Math.max(0, Math.min(max, i));
    d.strip.style.cursor = '';
    d.strip.scrollTo({ left: i * w, behavior: 'smooth' });
    setTimeout(function () { d.strip.style.scrollSnapType = ''; }, 400);
    setTimeout(function () { parkLinks(d.card, false); }, 60);
  }
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
  document.addEventListener('dragstart', function (e) {
    if (stripFrom(e.target)) e.preventDefault();
  }, true);
})();
